// Tijden van de aanloop naar het target ("Meter naar 100"). Net als bij
// ./charge.js staan ze hier en niet in de CSS: de wijzer, het getal, de
// tikken die je hoort en het moment waarop het beeld donkerder wordt moeten
// allemaal op dezelfde tel vallen. De component (AnimationLayer.js) tekent de
// wijzer met deze getallen, het geluid (audio/cues.js) tikt ermee, en de CSS
// krijgt de momenten als inline variabelen mee.
//
// Het idee: het beeld wordt donker en de meter uit de hero stijgt op en groeit
// naar het midden van het beeld. Onderweg zakt de wijzer terug naar 0, zoals
// een snelheidsmeter die bij het starten eerst zijn hele schaal afloopt. Dan
// loopt hij van 0 naar 100 - eerst traag, dan steeds sneller, zoals een motor
// die optrekt. Op 100 slaat hij aan: het beeld licht kort op, de meter veert,
// en het donker wordt dieper. Dan pas komt "GEHAALD".

// Zo lang doet de meter over de vlucht van de hero naar het midden. De wijzer
// zakt in dezelfde tijd van 100 naar 0: hij vertrekt vol, want het target is
// net gehaald en zo staat hij op dat moment ook in de hero.
export const targetFlyMs = 900;

// En dan een tel stil op 0 voor hij begint: een wijzer die al loopt voor hij
// stilstaat heeft geen begin.
export const targetSweepStartMs = targetFlyMs + 250;

// Zo lang doet de wijzer over 0 tot 100.
export const targetSweepMs = 3200;

// Hoe hard hij optrekt. De stand is (tijd)^dit: bij 1 loopt hij gelijkmatig,
// hoger begint trager en eindigt sneller. Bij 2,2 staat hij halverwege de tijd
// pas op een kwart, en haalt hij de laatste helft in het laatste kwart van de
// tijd. Zo voelt 100 als een klap en niet als een wijzer die uitloopt.
const sweepPower = 2.2;

// Het moment waarop hij de 100 raakt.
export const targetFullMs = targetSweepStartMs + targetSweepMs;

// De kaart "GEHAALD" valt zo lang na de 100: lang genoeg om de meter vol te
// zien staan en het donker te zien zakken, kort genoeg dat het één beweging
// blijft. Zie targetPartyGroup in ./party.js.
export const targetHandoffMs = targetFullMs + 700;

// Hoe lang de hele animatie staat. Langer dan de overgave, want het donker
// moet blijven tot het donker van de kaart het overneemt; zou dit eerder
// weggaan, dan licht het scherm daartussen even op.
export const targetChargeMs = targetHandoffMs + 500;

// Waar de wijzer staat na `ms`, van 0 tot 1: eerst leeglopen tijdens de
// vlucht (snel weg, zacht op 0), dan optrekken naar 100.
export function targetSweepAt(ms) {
  if (ms < targetFlyMs) {
    const flown = Math.max(0, ms / targetFlyMs);
    return (1 - flown) ** 2;
  }
  const part = Math.min(1, Math.max(0, (ms - targetSweepStartMs) / targetSweepMs));
  return part ** sweepPower;
}

// En andersom: wanneer de wijzer bij `fraction` (0 tot 1) is. Daar hangen de
// tikken aan, zodat je hoort dat hij sneller gaat.
export function targetMarkMs(fraction) {
  return targetSweepStartMs + targetSweepMs * fraction ** (1 / sweepPower);
}

// Zoveel tikken over de hele boog: om de 5%.
export const targetMarks = 20;
